import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";

export const ContentWrapper = styled.div`
	max-width: ${({ maxwidth }) => (maxwidth ? maxwidth : "85%")};

	${media.lessThan(breakpoints.mobile)`
        max-width: 100%;
    `}
`;
